import React from "react";
import Widget from "../Widget";

export default (node, convertNodeToElement) => {
  if (node.name === "widget") {
    if (typeof node.attribs.type === "undefined") {
      console.warn("Invalid type given for widget");
      return null;
    }

    const { type, ...attributes } = node.attribs;

    return <Widget type={type} attributes={attributes} />;
  }
};
